<template>
    <div class="tags-setting">
        <!-- 已选标签展示区域 -->
        <div class="selected-tags" v-if="selectedTags.length > 0">
            <span class="label">已选标签：</span>
            <el-tag
                v-for="(tag, index) in selectedTags"
                :key="index"
                closable
                :type="getTagType(index)"
                @close="handleRemoveTag(index)"
                class="tag-item"
            >
                {{ tag }}
            </el-tag>
        </div>

        <!-- 默认标签选择区域 -->
        <div class="default-tags" v-if="defaultTags.length > 0">
            <span class="label">默认标签：</span>
            <el-tag
                v-for="(tag, index) in defaultTags"
                :key="index"
                :type="isSelected(tag) ? 'success' : 'info'"
                @click="handleToggleTag(tag)"
                class="tag-item clickable-tag"
                :effect="isSelected(tag) ? 'dark' : 'plain'"
            >
                {{ tag }}
            </el-tag>
        </div>

        <!-- 自定义标签输入区域 -->
        <div class="custom-tag-input">
            <el-input
                v-model="newTag"
                placeholder="输入自定义标签，按回车添加"
                @keyup.enter.native="handleAddCustomTag"
                class="tag-input"
                clearable
            >
                <el-button slot="append" icon="el-icon-plus" @click="handleAddCustomTag">
                    添加
                </el-button>
            </el-input>
        </div>

        <!-- 提示信息 -->
        <div class="tips" v-if="showTips">
            <i class="el-icon-info"></i>
            <span>最多可选择 {{ maxTags }} 个标签</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TagsSetting',
    props: {
        // 已选中的标签列表
        value: {
            type: Array,
            default: () => []
        },
        // 默认标签列表
        defaultTags: {
            type: Array,
            default: () => ['社交', '颜值', '技术', '综合']
        },
        // 最大可选标签数
        maxTags: {
            type: Number,
            default: 10
        },
        // 是否显示提示信息
        showTips: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            selectedTags: [],
            newTag: ''
        };
    },
    watch: {
        value: {
            handler(newVal) {
                this.selectedTags = [...newVal];
            },
            immediate: true,
            deep: true
        }
    },
    mounted() {
        this.selectedTags = [...this.value];
    },
    methods: {
        /**
         * 判断标签是否已被选中
         */
        isSelected(tag) {
            return this.selectedTags.includes(tag);
        },

        /**
         * 切换标签选中状态
         */
        handleToggleTag(tag) {
            const index = this.selectedTags.indexOf(tag);
            if (index > -1) {
                // 已选中，则移除
                this.selectedTags.splice(index, 1);
            } else {
                // 未选中，检查是否超过最大数量
                if (this.selectedTags.length >= this.maxTags) {
                    this.$message.warning(`最多只能选择 ${this.maxTags} 个标签`);
                    return;
                }
                this.selectedTags.push(tag);
            }
            this.emitChange();
        },

        /**
         * 添加自定义标签
         */
        handleAddCustomTag() {
            const tag = this.newTag.trim();
            
            // 验证输入
            if (!tag) {
                this.$message.warning('请输入标签内容');
                return;
            }

            if (tag.length > 20) {
                this.$message.warning('标签长度不能超过20个字符');
                return;
            }

            // 检查是否已存在
            if (this.selectedTags.includes(tag)) {
                this.$message.warning('该标签已存在');
                return;
            }

            // 检查是否超过最大数量
            if (this.selectedTags.length >= this.maxTags) {
                this.$message.warning(`最多只能选择 ${this.maxTags} 个标签`);
                return;
            }

            // 添加标签
            this.selectedTags.push(tag);
            this.newTag = '';
            this.emitChange();
      
        },

        /**
         * 删除标签
         */
        handleRemoveTag(index) {
            this.selectedTags.splice(index, 1);
            this.emitChange();
        },

        /**
         * 获取标签类型（用于不同颜色展示）
         */
        getTagType(index) {
            const types = ['', 'success', 'warning', 'danger', 'info'];
            return types[index % types.length];
        },

        /**
         * 触发变更事件
         */
        emitChange() {
            this.$emit('input', this.selectedTags);
            this.$emit('change', this.selectedTags);
        }
    }
};
</script>

<style scoped lang="less">
.tags-setting {
    padding: 15px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    background-color: #fff;

    .selected-tags,
    .default-tags {
        margin-bottom: 15px;
        display: flex;
        align-items: flex-start;
        flex-wrap: wrap;

        .label {
            display: inline-block;
            min-width: 80px;
            color: #606266;
            font-size: 14px;
            line-height: 32px;
            margin-right: 10px;
        }

        .tag-item {
            margin: 5px;
            cursor: pointer;
            transition: all 0.3s;

            &:hover {
                transform: translateY(-2px);
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
            }
        }

        .clickable-tag {
            cursor: pointer;
            user-select: none;

            &:active {
                transform: scale(0.95);
            }
        }
    }

    .custom-tag-input {
        margin-top: 15px;

        .tag-input {
            width: 100%;
            max-width: 500px;
        }
    }

    .tips {
        margin-top: 10px;
        font-size: 12px;
        color: #909399;

        i {
            margin-right: 5px;
        }
    }
}
</style>
